/** When a sealed case opens, and how that reads. */

/** Tomorrow, 8 AM local: when a case sealed for "tomorrow" opens. */
export const tomorrowMorning = (from = Date.now()) => {
  const d = new Date(from);
  d.setDate(d.getDate() + 1);
  d.setHours(8, 0, 0, 0);
  return d.getTime();
};

export const whenLabel = (at: number) =>
  new Date(at).toLocaleString(undefined, {
    weekday: "long",
    hour: "numeric",
    minute: "2-digit",
  });
